import { hasKey } from '../typescript';
import {
    type Locale,
    LOCALE_US,
    LOCALE_DE,
    LOCALE_FR,
    LOCALE_IT,
    LOCALE_DEBUG,
    LOCALE_PSEUDO,
    LOCALE_ES,
} from '../locales/constants';

export const supportedCurrencies: Record<Locale, 'USD' | 'EUR'> = {
    [LOCALE_US]: 'USD',
    [LOCALE_DE]: 'EUR',
    [LOCALE_FR]: 'EUR',
    [LOCALE_IT]: 'EUR',
    [LOCALE_ES]: 'EUR',
    [LOCALE_PSEUDO]: 'USD',
    [LOCALE_DEBUG]: 'USD',
} as const;

type ValuesOf<T> = T[keyof T];

export type Currency = ValuesOf<typeof supportedCurrencies>;

function getCurrency(locale: string): Currency {
    if (hasKey(supportedCurrencies, locale)) {
        return supportedCurrencies[locale];
    } else {
        return 'USD';
    }
}

export { getCurrency };
